/**
 * Legacy builds used `backend.{domain}` before the platform standardized on `api.{domain}`.
 */
export function normalizeApiOrigin(url: string): string {
  const trimmed = url.replace(/\/$/, '');
  try {
    const parsed = new URL(trimmed);
    if (parsed.hostname.startsWith('backend.')) {
      parsed.hostname = `api.${parsed.hostname.slice('backend.'.length)}`;
      return parsed.origin;
    }
    return trimmed;
  } catch {
    return trimmed;
  }
}

/**
 * Resolve the Insight API origin used to fetch /api/public/bootstrap.
 * This is the only value that may remain in VITE_* at build time.
 */
export function resolveBootstrapApiBaseUrl(): string {
  const fromVite = import.meta.env.VITE_API_BASE_URL;
  if (fromVite) {
    return normalizeApiOrigin(fromVite);
  }

  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    if (hostname.startsWith('app.')) {
      return `${protocol}//${hostname.replace(/^app\./, 'api.')}`;
    }
  }

  return 'http://localhost:3000';
}
